import React from 'react';

import * as S from './styles';

import { AdvizedTest } from '../../types';

const AdvizedWidget = (props: AdvizedTest) => {
  const { title, date, grade, description } = props;

  return (
    <>
      <S.Title>{title}</S.Title>
      <S.Rating rate={grade} showCounter={false} />
      <S.Subtitle>{date}</S.Subtitle>
      <S.Description>{description}</S.Description>
    </>
  );
};

export default AdvizedWidget;
